<!-- Agent Workspace - Main container using Bootstrap grid layout like chatbot -->
<main>
  <div class="row">
    
    <!-- Agent Selector Sidebar (matches chat-sessions panel layout) -->
    <div 
      class="col-lg-3 col-md-3 col-sm-12 col-xs-12 position-sticky p-t-0 no-scroll-x bg-gray-50 chat-scroll sidebar-panel"
      [class.sidebar-collapsed]="!isSidebarOpen">
      <app-workspace-agent-selector
        [currentAgentId]="currentAgentId"
        [isAgentHubMode]="isAgentHubMode"
        [workbenchAccessAllowed]="workbenchAccessAllowed"
        [chatbotComponentRef]="chatbotComponentRef"
        (sidebarToggled)="toggleSidebar()"
        (agentSelected)="onAgentSelected($event)"
        (navigateToHub)="onNavigateToHub()"
        (navigateToAiWorkbench)="onNavigateToAiWorkbench()">
      </app-workspace-agent-selector>

      <!-- Chat History (Conversation list) - shown when an agent is selected -->
      <div *ngIf="!isAgentHubMode && currentAgentId && currentAgentId !== aiWorkbenchAgentId" class="agent-workspace-session-history">
        <hr class="divider-line m-b-4" />
        <app-session-history
          #sessionHistory
          [agentId]="currentAgentId"
          [currentSessionId]="(currentSessionId$ | async) ?? ''"
          [isResponseStreaming]="isResponseStreaming"
          (sessionSelected)="onAgentSessionSelected($event)"
          (newChatRequested)="onAgentNewChat()"
          (showDeleteSuccessMessage)="onShowDeleteSuccessMessage()"
          (showEditSuccessMessage)="onShowEditSuccessMessage()"
          (showPopupMessage)="onShowPopupMessage($event)">
        </app-session-history>
      </div>
    </div>

    <!-- Main Content Area -->
    <div 
      class="chat-right-box"
      [ngClass]="{
        'fullwidth-response': !isSidebarOpen,
        'sidebar-open': isSidebarOpen
      }">
      
      <!-- Floating toggle button when sidebar is closed (hidden during AI Workbench fullscreen overlay) -->
      <div class="floating-chat-menu" *ngIf="currentAgentId !== aiWorkbenchAgentId" [class.visible]="!isSidebarOpen">
        <button 
          alt="Expand" 
          [attr.data-tooltip]="'EXPAND_MENU_TOOLTIP' | translate"
          [attr.aria-label]="'EXPAND_MENU_TOOLTIP' | translate"
          (click)="toggleSidebar()" 
          class="chat-menu-item t-right t-no-arrow">
          <img src="../../../../assets/images/newchat/icon-toggle-button.svg" alt="Expand">
        </button>
      </div>

      <app-agent-main-area
        [isAgentHubMode]="isAgentHubMode"
        [currentAgentId]="currentAgentId"
        [workbenchAccessAllowed]="workbenchAccessAllowed"
        [workbenchAiAssistant]="workbenchAiAssistant"
        [isSidebarOpen]="isSidebarOpen"
        [loaderShow]="loaderShow"
        [userFName]="userFName"
        [chatbotComponentRef]="chatbotComponentRef"
        (agentSelected)="onAgentSelected($event)"
        (navigateToHub)="onNavigateToHub()"
        (toggleSidebar)="toggleSidebar()"
        (requestCloseSidebar)="closeSidebarForSourcePanel()">
      </app-agent-main-area>
    </div>

  </div>
</main>

<!-- Toast messages (success / error) -->
<div *ngIf="DeleteSuccessMessage || EditSuccessMessage" class="toast success" id='toast_message'>
  <div class="toast-icon">
    <img src="../../../../assets/images/newchat/correct.svg" width="18" alt="Success">
    <span *ngIf="DeleteSuccessMessage" id='delete_chat_success_message'>{{'DELETE_POPUP_TOASTER_MESSAGE' | translate}}</span>
    <span *ngIf="EditSuccessMessage" id='edit_chat_success_message'>{{'RENAME_POPUP_TOASTER_MESSAGE' | translate}}</span>
  </div>
  <a title="{{'CLOSE_TITLE_TEXT' | translate}}" href="javascript:void(0)" (click)="CloseSuccessMessage()"
    id='success_message_close_button'>
    <i class="icon-close1"></i>
  </a>
</div>

<!-- Error toast message -->
<div *ngIf="IsCustomErrorMessageVisible" class="toast error" id='error_toast_message'>
  <div>
    <p class="toast-icon" id='custom_error_message'>
      <img src="../../../../assets/images/newchat/exclamation.svg" width="18" alt="Error">
      {{ CustomErrorMessageText }}
    </p>
  </div>
  <a title="{{'CLOSE_TITLE_TEXT' | translate}}" href="javascript:void(0)" (click)="IsCustomErrorMessageVisible = false"
    id='error_message_close_button'>
    <i class="icon-close1"></i>
  </a>
</div>

<!-- Global popup for session-history rename/delete/share confirmations -->
<ng-container *ngIf="sessionHistoryComponent?.selectedItemForAction as actionItem">
  <div class="popup-backdrop"
    *ngIf="actionItem.isDeleting || actionItem.is_edited || actionItem.is_shared"
    tabindex="-1"
    (click)="$event.stopPropagation()"
    (keydown)="onPopupBackdropKeydown($event, actionItem)">

    <!-- Delete Confirmation -->
    <ng-container *ngIf="actionItem.isDeleting">
      <div class="popup">
        <div class="popup-header">
          <h1>{{ 'EDIT_RENAME_DROPDOWN_DELETE_POPUP_TITLE' | translate }}</h1>
        </div>
        <div class="popup-body">
          <p>{{ 'EDIT_RENAME_DROPDOWN_DELETE_POPUP_CONTENT' | translate }}</p>
        </div>
        <div class="popup-footer">
          <button (click)="sessionHistoryComponent!.deleteSession(actionItem)" class="button primary">{{ 'CONFIRM_BUTTON_TEXT' | translate }}</button>
          <button (click)="sessionHistoryComponent!.cancelDelete(actionItem)" class="button">{{ 'CANCEL_BUTTON' | translate }}</button>
        </div>
      </div>
    </ng-container>

    <!-- Rename -->
    <ng-container *ngIf="actionItem.is_edited">
      <div class="popup">
        <div class="popup-header">
          <h1>{{ 'RENAME_POPUP_HEADING' | translate }}
            <span class="char-counter" [class.char-counter-limit]="(actionItem.thread_name.length || 0) >= 100">{{ actionItem.thread_name.length || 0 }}/100</span>
          </h1>
        </div>
        <div class="popup-body">
          <input type="text" [(ngModel)]="actionItem.thread_name" class="margin-2 margin-top-5" maxlength="100">
          <div *ngIf="!actionItem.thread_name || actionItem.thread_name.trim() === ''" class="alert-danger">{{ 'EDIT_RENAME_POPUP_ALERT_MESSAGE' | translate }}</div>
          <div *ngIf="actionItem.thread_name && actionItem.thread_name.length >= 100" class="alert-danger">{{ 'RENAME_MAX_LENGTH_ERROR' | translate }}</div>
        </div>
        <div class="popup-footer">
          <button (click)="sessionHistoryComponent!.updateSession(actionItem)" class="button primary">{{ 'SAVE_BUTTON' | translate }}</button>
          <button (click)="sessionHistoryComponent!.cancelRename(actionItem)" class="button">{{ 'CANCEL_BUTTON' | translate }}</button>
        </div>
      </div>
    </ng-container>

    <!-- Share (same as chatbot and agent-chat-container) -->
    <ng-container *ngIf="actionItem.is_shared">
      <div class="popup">
        <div class="popup-header">
          <h1>{{ 'SHARE_LINK_POPUP_HEADING' | translate }} 
            <button type="button" class="close-button" (click)="onCancelShare(actionItem)">
              <img src="../../../assets/icons/close.svg" alt="Close">
            </button>
          </h1>
        </div>
        <div class="popup-body">
          <p class="popup-subtitle">{{ 'SHARE_LINK_POPUP_DESCRIPTION' | translate }}</p>
          <div class="form-button">
            <input type="text"
              [value]="actionItem.share_link || (actionItem.placeholder ? ('SHARE_LINK_PLACEHOLDER_AGENT' | translate) : '')"
              readonly 
              class="share-link-input" 
              style="background-color: #f5f5f5; cursor: default;">
            <button type="button" 
              (click)="onCopyShareLink(actionItem)" 
              class="button primary" 
              [class.copied]="shareLinkCopied"
              [disabled]="shareLinkCopied || !actionItem.share_link">
              <img [src]="shareLinkCopied ? '../../../assets/icons/check.svg' : '../../../assets/icons/link.svg'" 
                alt="Copy"
                class="copy-button-icon" 
                [class.link-icon]="!shareLinkCopied"
                [class.check-icon]="shareLinkCopied">
              {{ (shareLinkCopied ? 'SHARE_LINK_POPUP_COPIED_BUTTON' : 'SHARE_LINK_POPUP_COPY_BUTTON') | translate }}
            </button>
          </div>
        </div>
        <div class="popup-footer">
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
